// Private and transactional pages that should never appear in search results.
const NO_INDEX_PATHS = [
    /^\/my-account(\/|$)/,
    /^\/my-bookings(\/|-|$)/,
    /^\/my-sell-orders(\/|$)/,
    /^\/wishlist(\/|$)/,
    /^\/buy-used-[^/]+-car-\d+\/(checkout|book-test-drive|test-drive)(\/|$)/
];

export const NO_INDEX_ROBOTS = "noindex, nofollow";

export const isNoIndexPath = (pathName = "") => NO_INDEX_PATHS.some((pattern) => pattern.test(pathName.toLowerCase()));
